import PropTypes from "prop-types"
import React, { useState } from "react"
import "components/style.scss"
import { connect, useSelector } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import ProfileMenu from "../VerticalLayout/ProfileMenu"
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  switchClient,
} from "../../store/actions"

import { LOCAL_STORAGE_TAGS, URL_PATHS } from "constants/index"
import { ReactSelectDropDown } from "components/RenderInput"
import {
  Button,
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  UncontrolledDropdown,
} from "reactstrap"
import PlatformSetup from "./PlatformSetup"
import Search from "./Search"
import MpAdmisDropdown from "./MpAdmisDropdown"
import Downloads from "./Downloads"
import ModalComponent from "components/Modals"
import { useHistory } from "react-router-dom"
import encapptureIcon from "assets/images/encappture-icon.svg"

const Header = props => {
  const clientConfig = useSelector(state => state.Login.clientConfig)
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const isInboxEnabled = clientConfig?.web_inbox_enabled === 0 ? false : true
  function tToggle() {
    props.toggleLeftmenu(!props.leftMenu)
    if (props.leftSideBarType === "default") {
      props.changeSidebarType("condensed", isMobile)
    } else if (props.leftSideBarType === "condensed") {
      props.changeSidebarType("default", isMobile)
    }
  }

  function handleSelectClient(item) {
    props.switchClient(item.value, props.history)
  }

  const selectedVendor = localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))

  const vendor = props.vendorsList?.find(x => x?.id == selectedVendor)

  const logo = vendor ? vendor?.logo : ""

  const [searchToggle, setSearchToggle] = useState(false)
  const [collapseToggle, setCollapseToggle] = useState(false)
  const [openDownloadsModal, setOpenDownloadsModal] = useState(false)
  const history = useHistory()

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="25" />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="60" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {props.vendorsList &&
              props.vendorsList.length > 0 &&
              selectedVendor && (
                <div className={"mega-menu-container"}>
                  <ReactSelectDropDown
                    optionData={props.vendorsList}
                    defaultValueId={+selectedVendor}
                    onSelectItem={item => handleSelectClient(item)}
                  />
                </div>
              )}
            {user && user?.godMode && (
              <div className={"mega-menu-container"}>
                <div className="d-none d-lg-block">
                  <MpAdmisDropdown />
                </div>
              </div>
            )}
            {/* <div className={"mega-menu-container"}>
              <div className="d-none d-lg-block">
                <Dropdown
                  isOpen={searchToggle}
                  toggle={() => {
                    setSearchToggle(!searchToggle)
                  }}
                  className="mx-3"
                >
                  <DropdownToggle color="light">Search</DropdownToggle>
                  <DropdownMenu>
                    <Search />
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div> */}
          </div>
          <div className="d-flex d-none d-lg-block">
            <div className={"mega-menu-container"}>
              {isInboxEnabled && (
                <div
                  className="mx-2"
                  onClick={() => {
                    history.push("/inbox_inb")
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bx bx-message font-size-16 align-middle me-1 d-none d-xl-inline-block" />
                  <span className="align-middle">Inbox</span>
                </div>
              )}

              <div
                className="mx-2"
                onClick={() => {
                  const evnironment = process.env.REACT_APP_ENV
                  let url = "https://admin.encappture.com/"
                  switch (evnironment) {
                    case "dev":
                      url = "https://admin.dev.markedprivate.com"
                      break
                    case "live":
                      url = "https://admin.encappture.com/"
                    case "qa":
                      url = "https://admin.qa.encappture.com/"
                    default:
                      url = "https://admin.encappture.com/"
                  }
                  window.open(url)
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={encapptureIcon} alt="Icon" className="switch-icon" />
                <span className="align-middle">Legacy Dashboard</span>
              </div>

              <UncontrolledDropdown>
                <DropdownToggle
                  className="btn header-item waves-effect"
                  id="page-header-user-dropdown"
                  tag="button"
                >
                  <i className="bx bx-cloud-download font-size-20 align-middle d-none d-xl-inline-block" />
                  <span className="align-middle"> Downloads </span>
                </DropdownToggle>
                <DropdownMenu right>
                  <Downloads />
                </DropdownMenu>
              </UncontrolledDropdown>
              <PlatformSetup />
              <div
                className="mx-2"
                onClick={() => {
                  window.open("https://app.encappturehomecare.com/knowledge")
                }}
                style={{ cursor: "pointer" }}
              >
                <i className="bx bx-help-circle font-size-16 align-middle me-1 d-none d-xl-inline-block" />
                <span className="align-middle">Help Center</span>
              </div>

              <ProfileMenu />
            </div>
          </div>
          <div className="d-flex d-lg-none">
            <div className={"mega-menu-container"}>
              <Button
                type="button"
                className="navbar-toggler"
                style={{
                  border: "1px solid gray",
                }}
                onClick={() => {
                  setCollapseToggle(!collapseToggle)
                }}
              >
                <i
                  className="bx bx-menu font-size-24"
                  style={{ color: "black" }}
                />
              </Button>
            </div>
          </div>
        </div>
        <Collapse
          isOpen={collapseToggle}
          navbar
          style={{ textAlign: "center" }}
          className="d-lg-none"
        >
          <Nav navbar>
            <NavItem
              className="my-2"
              style={{ color: "black", cursor: "pointer" }}
            >
              <span onClick={() => props.history.push(URL_PATHS.PROFILE)}>
                Profile
              </span>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret style={{ color: "black" }}>
                MP ADMINS
                <i className="mdi mdi-chevron-down ms-1" />
              </DropdownToggle>
              <DropdownMenu style={{ textAlign: "center", boxShadow: "none" }}>
                <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.CLIENTS)}
                >
                  Clients
                </DropdownItem>
                <DropdownItem
                  onClick={() =>
                    props.history.push(URL_PATHS.ADMIN_ROLES_MANAGEMENT)
                  }
                >
                  Admin Roles
                </DropdownItem>
                <DropdownItem
                  onClick={() =>
                    props.history.push(URL_PATHS.PERMISSIONS_MANAGEMENT)
                  }
                >
                  Permissions
                </DropdownItem>

                <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.SITE_USERS)}
                >
                  Clients' end-users
                </DropdownItem>
                <DropdownItem divider />
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret style={{ color: "black" }}>
                Platform Setup
                <i className="mdi mdi-chevron-down ms-1" />
              </DropdownToggle>
              <DropdownMenu style={{ textAlign: "center", boxShadow: "none" }}>
                <DropdownItem
                  onClick={() =>
                    props.history.push(URL_PATHS.PLATFORM_SETTINGS)
                  }
                >
                  Platform Settings
                </DropdownItem>
                {/* <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.ONBOARDING_FLOW)}
                >
                  Onboarding flow
                </DropdownItem> */}
                <DropdownItem
                  onClick={() =>
                    props.history.push(URL_PATHS.SETUP_LANDING_PAGE)
                  }
                >
                  Landing Screen
                </DropdownItem>
                <DropdownItem
                  onClick={() =>
                    props.history.push(URL_PATHS.SETUP_LIST_SCREEN)
                  }
                >
                  List Screen
                </DropdownItem>
                <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.SETUP_CONTACT_US)}
                >
                  Contact Us Screen
                </DropdownItem>
                <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.TAGS)}
                >
                  Tag Setup
                </DropdownItem>
                <DropdownItem
                  onClick={() => props.history.push(URL_PATHS.BUSINESS_UNITS)}
                >
                  Business Units
                </DropdownItem>
                <DropdownItem divider />
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem
              className="my-2"
              style={{ cursor: "pointer", color: "black" }}
            >
              <span
                onClick={() => {
                  window.open("https://app.encappturehomecare.com/knowledge")
                }}
              >
                Help Center
              </span>
            </NavItem>
            <NavItem
              className="my-2"
              style={{ color: "black", cursor: "pointer" }}
            >
              <span
                onClick={() => {
                  setOpenDownloadsModal(true)
                }}
              >
                Downloads
              </span>
            </NavItem>
            <NavItem
              className="my-2"
              style={{ color: "black", cursor: "pointer" }}
            >
              <span onClick={() => props.history.push(URL_PATHS.LOGOUT)}>
                Logout
              </span>
            </NavItem>
          </Nav>
        </Collapse>
        <ModalComponent
          title="Downloads"
          open={openDownloadsModal}
          onClose={() => setOpenDownloadsModal(false)}
        >
          <Downloads isModal={true} />
        </ModalComponent>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  const { vendorsList } = state.clients
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    vendorsList,
  }
}

export default withRouter(
  connect(mapStatetoProps, {
    showRightSidebarAction,
    toggleLeftmenu,
    changeSidebarType,
    switchClient,
  })(Header)
)
